import axios from 'axios';

interface AddressResponse {
    results: [
        {
            address1: string;
            address2: string;
            address3: string;
            address4: string;
            kana1: string;
            kana2: string;
            kana3: string;
            kana4: string;
            prefcode: string;
            postcode: string;
            prefname: string;
            cityname: string;
            townname: string;
        }
    ];
    status: number;
}

const getAddressByPostalCode = async (zipcode: string, isDischarge: boolean): Promise<any> => {
    try {
        const response = await axios.get<AddressResponse>(`https://zip-cloud.appspot.com/api/search?zipcode=${zipcode}`);
        const data = response.data;

        if (data.results && data.results.length > 0) {
            const address = data.results[0];
            const addressParts = [address.address1, address.address2, address.address3].filter(Boolean);
            return isDischarge ? addressParts : addressParts.join('');
        }
        
        return '';
    } catch {
        return '';
    }
};



export default getAddressByPostalCode;
